define('../app/fukit/behavior/enable.loading.on.model.request.behavior',['require','marionette'],function(require) {
  var Mn = require('marionette');

  var EnableLoadingOnModelRequestBehavior = Mn.Behavior.extend({
    modelEvents: {
      request: 'onModelRequest',
      sync: 'onModelSync',
      error: 'onModelError',
    },

    onModelRequest: function() {
      this.view.loading = true;
    },

    onModelSync: function() {
      this.view.loading = false;
    },

    onModelError: function() {
      this.view.loading = false;
    },
  });

  return EnableLoadingOnModelRequestBehavior;
});

